import { render, staticRenderFns } from "./WishlistItem.vue?vue&type=template&id=ec298ce4&scoped=true"
import script from "./WishlistItem.vue?vue&type=script&lang=js"
export * from "./WishlistItem.vue?vue&type=script&lang=js"
import style0 from "./WishlistItem.vue?vue&type=style&index=0&id=ec298ce4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec298ce4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VIcon,VImg})
